import { cn } from '@/utils/cn'
import { cva, type VariantProps } from 'class-variance-authority'
import { HTMLProps, PropsWithChildren } from 'react'

const tagVariants = cva(
  'w-fit rounded-sm !text-caption-01-semi text-primary-foreground',
  {
    variants: {
      variant: {
        product: 'bg-primary px-1.5 py-0.5',
        productDetail: 'rounded-[12px] bg-gray-2 px-[8px] py-[4px] text-gray-6',
        rate: 'bg-point-red px-1.5 py-0.5',
        rank: 'rounded-none rounded-br-[5px] rounded-tl-[5px] bg-primary px-[9px] py-1',
        notification: 'rounded-xl bg-primary px-2 py-1',
        priceDown:
          'flex items-center gap-1 rounded-md bg-primary-light px-[6px] py-1 text-primary',
      },
      size: {
        md: '',
        sm: 'py-[3.5px] !text-caption-03-semi',
      },
      color: {
        orange: 'bg-point-orange-bg text-point-orange',
        blue: 'bg-point-blue-bg text-point-blue',
        purple: 'bg-point-purple-bg text-point-purple',
        pink: 'bg-point-pink-bg text-point-pink',
        green: 'bg-point-green-bg text-point-green',
        gray: 'bg-gray-7',
      },
    },
    defaultVariants: {
      variant: 'product',
    },
  },
)

interface TagProps extends PropsWithChildren<VariantProps<typeof tagVariants>> {
  className?: HTMLProps<HTMLElement>['className']
}

export function Tag({ children, variant, size, color, className }: TagProps) {
  return (
    <div className={cn(tagVariants({ variant, size, color }), className)}>
      {variant === 'notification' ? (
        <div className="flex">
          <div className="mr-1 size-4 rounded-full bg-gray-2" />
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  )
}
